import React from "react";
import { Nav } from "react-bootstrap";

import "./ReportNav.css";

const ReportNav = (props) => {
	return (
		<React.Fragment>
			<h1>Reports</h1>
			<div className="navDiv" ></div>
			<Nav className="flex-column">
				<Nav.Link href="/report/onlineScheduling">Online Scheduling Report</Nav.Link>
			</Nav>
		</React.Fragment>
	);
};

export default ReportNav;